import { BadgeBg } from "components/base/Badge";
import { PageBreadcrumbItem } from "components/common/PageBreadcrumb";
import { currencyFormat } from "helpers/utils";
import { format } from "date-fns";

export type VendaType = {
  id: number;
  data: string;
  cliente: string;
  valorTotal: number;
  numeroNFe: number;
  cancelado: boolean;
  quantidadeItens: number;
  usuario: string;
  empresaId: number;
  empresaNomeFantasia: string;
  onView?: (id: number) => void;
};

export type VendaDetalhesType = {
  id: number;
  data: string;
  cliente: string | null;
  clienteId: number | null;
  usuario: string;
  valorTotal: number;
  valorBruto: number;
  descontoTotal: number;
  numeroNFe: number;
  chaveNFe: string | null;
  cancelado: boolean;
  motivoCancelamento: string | null;
  observacao: string | null;
  itens: ItemVendaType[];
  pagamentos: PagamentoVendaType[];
};

export type ItemVendaType = {
  produtoId: number;
  descricao: string;
  codigoDeBarras: string | null;
  quantidade: number;
  valorUnitario: number;
  valorTotal: number;
  desconto: number;
};

export type PagamentoVendaType = {
  descricao: string;
  valor: number;
};

export const vendasBreadcrumbItems: PageBreadcrumbItem[] = [
  {
    label: "Operacional",
    url: "#!",
  },
  {
    label: "Vendas",
    active: true,
  },
];

export const formatarDataVenda = (data: string): string => {
  return format(new Date(data), 'dd/MM/yyyy HH:mm');
};

export const formatarValor = (valor: number): string => {
  return currencyFormat(valor);
};

export const formatarStatusVenda = (cancelado: boolean): string => {
  return cancelado ? "Cancelada" : "Concluída";
};

export const getStatusVendaClass = (cancelado: boolean): BadgeBg => {
  return cancelado ? "danger" : "success";
};
